import React, { useState } from 'react';
import { useLangue } from '../i18n/LangueContext';

const Processus = () => {
  const { t } = useLangue();
  const [ouverte, setOuverte] = useState(0);

  return (
    <div className="etapes">
      {t.etapes.map((e, i) => (
        <div key={e.titre} className={`etape${ouverte === i ? ' ouverte' : ''}`}>
          <button
            type="button"
            className="etape-btn"
            aria-expanded={ouverte === i}
            onClick={() => setOuverte(ouverte === i ? -1 : i)}
          >
            <span className="etape-titre">{e.titre}</span>
            <span className="plus" aria-hidden="true" />
          </button>
          <div className="etape-corps">
            <div>
              <div className="etape-in">
                {e.paragraphes.map((p, k) => (
                  <p key={k}>{p}</p>
                ))}
                {e.liste && (
                  <ul className="liste-fine">
                    {e.liste.map((l) => (
                      <li key={l}>{l}</li>
                    ))}
                  </ul>
                )}
                {e.apres &&
                  e.apres.map((p, k) => (
                    <p key={`a${k}`} style={{ marginTop: '1.2rem' }}>{p}</p>
                  ))}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Processus;
